<script setup lang="ts">
import { nextTick, onMounted, provide, ref, watch } from 'vue';
import { RouterView } from 'vue-router'
import { useSystemStore } from '@/stores'

const isRouterAlice = ref(true);
const system = useSystemStore();

provide('app',{
  reload: () =>{
    isRouterAlice.value = false;
    nextTick(() => {
      isRouterAlice.value = true
    })
  }
})

// 切换语言时，重新渲染页面，并请求接口
const i18Reload = ref(true)
watch(() =>  system.currentI18, () => {
  i18Reload.value = false;
  nextTick(() => {
    i18Reload.value = true;
  })
})
onMounted(async() => {
  system.getComponentData({page: 'HOME'})
})
</script>

<template>
  <header-layout v-if="i18Reload"/>
  <section v-if="i18Reload">
    <router-view v-if="isRouterAlice"/>
  </section>
  <footer-layout/>
</template>
<style lang="less" scoped>
section{
  min-height: calc(100vh - 197px);
  // background: #ECECEA;
}
</style>
